// Add support for IE 9, 10, 11
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Companion methods to these are available in Ruby at /lib/encryption/obfuscate.rb
// Simple hashing algorithm to obfuscate url strings passed from Rails server to React frontend
// NB: This is NOT ENCRYPTION.  It makes no pretence at "guaranteeing" security (or even attempting to).
// Inspiration from:
// https://coderwall.com/p/jpd4zq/simple-method-to-obfuscate-strings-in-javascript

// Converts a string into a - separated string of ASCII character codes
export function obfuscate(string) {
  return string
    .split('')
    .map((b) => {
      return b.charCodeAt(0);
    })
    .join('-');
}

// Converts obfuscated string back to plain text
export function deobfuscate(string) {
  // Return empty string for empty inputs
  if (!string || string.length == 0) {
    return '';
  }
  return string
    .split('-')
    .map((byte) => {
      return String.fromCharCode(parseInt(byte));
    })
    .join('');
}
